/** Kids shoe sizes — approximate; height/age vary by brand */
export const kidsShoeSizes = [
  { category: 'kids-shoes', gender: 'kids', eu: '26', uk: '8.5', us: '9', cm: '16.0', age: '3–4' },
  { category: 'kids-shoes', gender: 'kids', eu: '27', uk: '9', us: '10', cm: '16.5', age: '4' },
  { category: 'kids-shoes', gender: 'kids', eu: '28', uk: '10', us: '10.5', cm: '17.5', age: '4–5' },
  { category: 'kids-shoes', gender: 'kids', eu: '29', uk: '11', us: '11', cm: '18.0', age: '5' },
  { category: 'kids-shoes', gender: 'kids', eu: '30', uk: '11.5', us: '12', cm: '18.5', age: '5–6' },
  { category: 'kids-shoes', gender: 'kids', eu: '31', uk: '12', us: '12.5', cm: '19.0', age: '6' },
  { category: 'kids-shoes', gender: 'kids', eu: '32', uk: '13', us: '13', cm: '19.5', age: '6–7' },
  { category: 'kids-shoes', gender: 'kids', eu: '33', uk: '1', us: '1', cm: '20.5', age: '7–8' },
  { category: 'kids-shoes', gender: 'kids', eu: '34', uk: '2', us: '2', cm: '21.5', age: '8–9' },
  { category: 'kids-shoes', gender: 'kids', eu: '35', uk: '2.5', us: '3', cm: '22.0', age: '9–10' },
  { category: 'kids-shoes', gender: 'kids', eu: '36', uk: '3.5', us: '4', cm: '23.0', age: '10–11' },
  { category: 'kids-shoes', gender: 'kids', eu: '37', uk: '4', us: '5', cm: '23.5', age: '11–12' },
];

export function getKidsShoeSizes() {
  return kidsShoeSizes;
}
